<script setup lang="ts">
defineProps({
  showLoginButton: {
    type: Boolean,
    required: true,
  },
  hideStepIndicator: {
    type: Boolean,
    default: false,
  },
  step: {
    type: String,
    required: true,
  },
  redirectUrl: {
    type: String,
    required: true,
  },
  activeStep: {
    type: String,
    required: true,
  },
})

const { isAuthorized, user, login, loginUrl } = useAuth()
</script>

<template>
  <UStep
    :hide-step-indicator="hideStepIndicator"
    :is-active-step="activeStep === step"
  >
    <template #step>{{ step }}</template>
    <template #title>
      <p
        v-if="isAuthorized"
        class="font-numeraWebRegular text-3xl"
      >
        Logget inn som {{ user?.fullName }}
      </p>
      <p v-else>Logg inn eller registrer deg med Vipps</p>
    </template>
    <template #content>
      <div v-if="!isAuthorized" class="font-national2">
        <p>
          Ved å logge inn og registerere deg som bruker på Kunne,
          samtykker du til vår
          <a class="underline" href="/om/personvern?side=3302"
            >personvernerklæring</a
          >.
        </p>
        <br />
      </div>
      <div
        v-if="showLoginButton && !isAuthorized"
        class="flex flex-col gap-10 font-numeraWebRegular text-3xl <md:gap-2"
      >
        <a
          v-wave
          class="fit-c block w-fit rounded-full"
          :href="loginUrl"
          @click.prevent="login(redirectUrl)"
        >
          <img
            src="/images/vipps-logginn.svg"
            alt="Logg inn med Vipps"
            class="h-18"
          />
        </a>
        <div class="font-national2 text-lg">
          Har du ikke Vipps?
          <a
            href="https://vipps.no/hjelp/vipps/kom-i-gang-med-vipps/hvordan-skaffer-jeg-meg-vipps/"
            target="_blank"
            style="font: inherit; text-decoration: underline"
            >Slik går du frem for å skaffe Vipps.</a
          >
        </div>
      </div>
    </template>
  </UStep>
</template>
